import { notAvailable } from 'core/common/constants';
import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store';
import { UserSettings } from 'core/user/entities';

export const updateUserSettingsRequest =
  (data: UserSettings): AppThunk =>
  async (dispatch, _, services) => {
    const { loggingService, settingsService, errorMonitoringService } = services;

    try {
      await settingsService.updateUserSettings(data);
    } catch (e) {
      const err = normalizeError(e);
      loggingService.error(err);

      errorMonitoringService.captureError(err, {
        tags: {
          ...data,
          get_params: location.search || notAvailable,
          error_message: err.message,
          error_reason: 'update_user_settings',
        },
      });
    }
  };
